/**
 * A Dialog that goes full-screen on phones (below the `sm` breakpoint).
 * First-run and form dialogs use it so a Stepper or a long form is never
 * cramped into a floating card on a 375px screen; short confirms keep the
 * plain Dialog.
 */
import { Dialog, DialogProps, useMediaQuery, useTheme } from '@mui/material';

export default function ResponsiveDialog(props: DialogProps) {
  const theme = useTheme();
  const phone = useMediaQuery(theme.breakpoints.down('sm'));
  return <Dialog fullScreen={phone} {...props} />;
}
